import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {MarketingColors} from "./constants.ts";
import * as mediaQueries from "./media-queries.ts";

const SUPPORTERS_BACKGROUND_EDGE =
    "M193.85 1.356L-18.72 36.724c-43.745 7.279-77.472 42.499-82.849 86.519l-57.734 472.632C-166.583 655.469-120.079 708-60.041 708H1324c55.23 0 100-44.772 100-100V132.617c0-48.4-34.66-89.852-82.3-98.42l-72.92-13.117a99.987 99.987 0 0 0-17.7-1.58H943L693 0H210.262c-5.499 0-10.988.454-16.412 1.356z";

export const SupportersBackground = (): React.ReactElement => (
    <svg
        viewBox="0 0 1366 708"
        height="708"
        className={css(styles.supportersBackground)}
        preserveAspectRatio="none"
        aria-hidden="true"
    >
        <path d={SUPPORTERS_BACKGROUND_EDGE} fill={MarketingColors.lightTan} />
    </svg>
);

const styles = StyleSheet.create({
    supportersBackground: {
        position: "absolute",
        overflow: "visible",
        zIndex: -1,
        top: 0,
        alignSelf: "center",
        minHeight: "100%",
        width: 1600,
        [mediaQueries.xlDesktopOrLarger]: {
            width: "110%",
        },
        [mediaQueries.smallDesktopOrSmaller]: {
            height: "100%",
            top: 0,
            bottom: 0,
        },
    },
});
